<template>
	<mu-container fluid class="mb-3">
		<title-static :title="$t('module_trucks.Bucerias.title')"></title-static>
		<mu-row>
			<mu-col span="10" offset="1">
				<image-static image_src="/images/static/boletos-de-autobus-bucerias.jpg"></image-static>
				<div class="content-destination">
					<mu-row>
						<mu-col span="12">
							<div class="mt-1 pl-4 pr-2">
								<description
									:destination="$t('module_trucks.Bucerias.title')"
									:description="$t('module_trucks.Bucerias.text')"
								></description>
								<contact-phone
									:contact_title="$t('module_trucks.contact.title')"
									:contact_description="$t('module_trucks.contact.description')"
								></contact-phone>
							</div>
						</mu-col>
					</mu-row>
				</div>
			</mu-col>
		</mu-row>
	</mu-container>
</template>

<script>
import Image_static from "./image_static.vue";
import Title_static from "./title_static.vue";
import Description from "./description.vue";
import Contact_phone from "./contact_phone.vue";

export default {
	name: "truck_bucerias",
	components: {
		titleStatic: Title_static,
		imageStatic: Image_static,
		description: Description,
		contactPhone: Contact_phone,
	},
};
</script>

<style>
.content-destination {
  font-size: 18px;
  white-space: normal;
  line-height: 2em;
}
</style>